import React from "react";
import { useFormatPrice } from "hooks";

const CustomerAccounts = ({ balance }) => {
  const formatPrice = useFormatPrice();
  return (
    <div className="p-[15px] flex flex-wrap gap-5 justify-normal md:justify-around">
      {/* Account Balance */}
      <div className="flex flex-col text-gray-500 font-medium">
        <span className="text-[14px]">Account Balance</span>
        <span className="text-[22px]">- {formatPrice(balance)}</span>
        {/* <span className="text-[12px]">
          On account limit available: {formatPrice(0)}
        </span> */}
      </div>
      {/* Store Credit */}
      <div className="flex flex-col text-gray-500 font-medium">
        <span className="text-[14px]">Store Credit</span>
        <span className="text-[22px]">{formatPrice(balance)}</span>
      </div>
    </div>
  );
};

export default CustomerAccounts;
